import { columnsOrderedTable } from "@thelpers/columnsTableHelper"

export const collectionAdministrationTableColumns = ({
    columns = [],
    currencySymbol,
    handleSave
}) => {
    const defaultColumns = []

    const editableColumns = [
        ...defaultColumns,
        ...columns
    ].filter(col => col.key !== 'debtor_name' && col.key !== 'place_name').map(col => ({
        ...col,
        dataIndex: col.key,
        render: (text) => <span>{currencySymbol} {parseFloat(text ?? '0')?.toFixed?.(2)}</span>
    }))

    const newColumns = columns.length ? columnsOrderedTable({
        defaultColumns,
        backendColumns: columns,
        editableColumns,
        titleUpperCase: true
    }) : defaultColumns

    //Añadir el evento onCell para poder usar el componente EditableCellTable
    const finalColumns = newColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
            }),
        }
    });


    return finalColumns
}